export default __webpack_public_path__ + "static/media/air.c55c97e9.svg";